/**
 * Public reviews, quoted as written.
 *
 * These are real people's words, so they live in one place and are used
 * verbatim — never paraphrased, trimmed or "tidied" at the call site. Each page
 * picks the ones it wants from REVIEWS by name, so adding a review here doesn't
 * silently change a page that didn't ask for it.
 */

export type Review = {
  /** Paragraphs, in order. Kept split so long reviews render as written. */
  quote: string[]
  name: string
  /** How they're described under the quote — their relationship to us. */
  role: string
}

export const REVIEWS = {
  /** A veterinary business owner. Their full review, unabridged. */
  janine: {
    quote: [
      "I have been using Pet Aftercare Cremation services for my veterinary business and I have found both Molly and Ray professional, accommodating and so easy to deal with.",
      "I feel they have something really special to offer the veterinary and pet community in Christchurch. What they have is not the normal pet cremation service that has up until now been on offer in Christchurch. From the unique way that the client can follow their fur babies journey all the way through to the lovely little touches that are all included like fur vials, Pawprints and their memorial page.",
      "They are extremely compassionate and kind to every fur baby that is brought into their care, this is super important to me and means a lot, as I feel they are an extension of my business ❤️. I 100% recommend them.",
    ],
    name: "Janine Cumming",
    role: "Veterinary business owner",
  },

  /** Archie's family — names the stone, the fur, the paw print, the delivery. */
  leanne: {
    quote: [
      "We found the service brilliant. Archie was treated with respect and dignity. We love our beautiful stone and so appreciated the extras like his little jar of fur and his paw print. Also appreciated the door to door service. Thanks again!",
    ],
    name: "Leanne A.",
    role: "Archie's family",
  },

  /** Mochi's family — names the rubbish bag and the children's goodbyes. */
  andrew: {
    quote: [
      "We unexpectedly lost our cat Mochi and chose the private service so she'd come home to us without us having to go back to the clinic again. You'd think the bag they use is such a small thing but it mattered—she wasn't just bundled into a plastic rubbish bag like when we lost our previous cat, which is what I'd been dreading. The kids got to write some goodbyes on the bag. I didn't expect to cry, but here we are. Thank you for treating her like she mattered.",
    ],
    name: "Andrew Sutton",
    role: "Mochi's family",
  },

  sue: {
    quote: ["Fantastic, compassionate and professional service. Highly recommended."],
    name: "Sue Ambler",
    role: "Pet owner",
  },
} satisfies Record<string, Review>

/**
 * "Andrew Sutton" → "Andrew S."
 *
 * The reviews are public under full names, but a page about someone's pet dying
 * is not the place to print a family's surname back at them. Names already
 * given to us abbreviated pass through untouched.
 */
export function shortName(name: string): string {
  const parts = name.trim().split(/\s+/)
  if (parts.length < 2) return name
  const last = parts[parts.length - 1]
  if (last.endsWith(".")) return name
  return `${parts.slice(0, -1).join(" ")} ${last[0]}.`
}
